import { DefaultFetchService } from "app/services/fetchService";
import type { IAudienceMatrixAPI } from "./types";

const fetchService = DefaultFetchService.getInstance();

export const overlapTableDataFetcher = ({ params }): Promise<IAudienceMatrixAPI> => {
    return new Promise((resolve) => {
        fetchService
            .get<IAudienceMatrixAPI>(`api/websiteanalysis/GetAudienceInterestsMatrix`, params)
            .then((results) => {
                resolve(results);
            })
            .catch((e) => {
                resolve({});
            });
    });
};
